export default __webpack_public_path__ + "static/media/163a066b985c74.bf061b62.jpg";